module.exports = __webpack_public_path__ + "static/media/dashboard.f6ddc132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/dashboard.svg
// module id = 2703
// module chunks = 0